import { inject, computed } from "vue";
/* empty css                     */
import { FORM_CONTROL_KEY } from "../components/form-control/type.js";
const useFormControl = (props, emit) => {
  const {
    hasError,
    hint: formControlHint,
    size: formControlSize,
    model: formControlModel
  } = inject(FORM_CONTROL_KEY, {});
  const size = computed(() => {
    return props.size || formControlSize;
  });
  const model = computed({
    get: () => {
      if (props.modelValue !== void 0) return props.modelValue;
      return formControlModel?.value;
    },
    set: (val) => {
      if (formControlModel) {
        formControlModel.value = val;
      }
      emit("update:modelValue", val);
    }
  });
  const hintText = computed(() => props.hint ?? formControlHint?.value ?? "");
  const hasHint = computed(() => !!hintText.value && !(hasError?.value ?? false) && !props.disabled);
  return {
    model,
    hasError,
    hasHint,
    hint: formControlHint,
    hintText,
    size
  };
};
export {
  useFormControl
};
//# sourceMappingURL=useFormControl.js.map
